// This is how a normal module looks like. You can copy paste this
// for any new module you want to create. Then you can import it in
// main.js and call "init()" to execute the code.


const Formstyler = ((($) => {

  // try to declare variables that are going to be used to improve performance
  let inputs;

  // in this function you get all the div elements that need to be manipulated
  function init() {
    inputs = $('input[type="checkbox"]');
    $(inputs).styler();

    $('.header-loc a').on('click', function(e) {
      e.preventDefault();
      $(this).parents('.header-loc').toggleClass('active');
      $('body').toggleClass('has-popup');
      $('.Map').toggleClass('show');
      $('.Contact').removeClass('show');
      $('.header-contact').removeClass('active');
    });

    $('.header-contact a').on('click', function(e) {
      e.preventDefault();
      $(this).parents('.header-contact').toggleClass('active');
      $('body').toggleClass('has-popup');
      $('.Contact').toggleClass('show');
      $('.Map').removeClass('show');
      $('.header-loc').removeClass('active');
    });

    $('.close-popup').on('click', function(e) {
      e.preventDefault();
      if($(this).parents('.show').hasClass('Contact')) {
        $('.Contact').removeClass('show');
        $('.header-contact').removeClass('active');
        $('body').removeClass('has-popup');
      }
      else {
        $('.Map').removeClass('show');
        $('.header-loc').removeClass('active');
        $('body').removeClass('has-popup');
      }
    });

    $('.has-popup').on('click', '.Main', function(e) {
      e.preventDefault();
      $(this);
      if($('.Contact').hasClass('show')) {
        $('.Contact').removeClass('show');
        $('.header-contact').removeClass('active');
        $('body').removeClass('has-popup');
      }
      else {
        $('.Map').removeClass('show');
        $('.header-loc').removeClass('active');
        $('body').removeClass('has-popup');
      }
    });
  }
  return {
    init,
  };
}))(jQuery);


// don't forget to export
export default Formstyler;



// WEBPACK FOOTER //
// ./src/static/js/modules/formstyler.js